import React from "react";
import { motion } from "framer-motion";
import CarRentalForm from "../CarRentalForm/CarRentalForm";
import BgImage from "../../assets/images/background-image.jpg";

const Hero = () => {
  return (
    <section className="relative bg-cover bg-center min-h-[90vh] md:h-[90vh] overflow-y-hidden" style={{ backgroundImage: `url(${BgImage})` }}>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <motion.div 
        className="relative text-center z-10 text-white p-4 sm:p-10 w-full mx-auto h-full items-center Aleo overflow-y-hidden"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <CarRentalForm />
      </motion.div>
    </section>
  );
};

export default Hero;